<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs3 class="text-xs-left">
                        <v-autocomplete v-model="channel" :items="channelsDropDown" @change="channelHandler" label="Select a channel"></v-autocomplete>
                        <v-text-field v-model="merchantTransactionId" label="Merchant Transaction ID" :rules="rules.required" required></v-text-field>
                        <v-text-field v-model="email" label="Email address" :rules="rules.email" required></v-text-field>
                        <v-text-field v-model="amount" label="Amount" :rules="rules.required" required></v-text-field>
                        <v-select v-model="currency" :items="selectedChannel.currencies" :rules="rules.required" required label="Please select a currency" :disabled="!('currencies' in selectedChannel)"></v-select>
                        <v-switch v-model="emailSwitch" label="Send an email"></v-switch>
                        <v-btn class="ml-0" @click="onSubmit" color="primary mr-0" >Submit</v-btn>
                        <div class="mt-3" v-html="payByLink"></div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return { 
            rules: { required: [ v => !!v || 'Required' ],
                     email: [ v => this.emailRule(v) ],
                },
            merchantTransactionId: null,
            email: null,
            amount: null,
            currency: null,
            channel: null,
            channels: [],
            channelsDropDown: [],
            selectedChannel: [],
            payByLink: null,
            emailSwitch: false
        }
    },
    beforeMount() {
       this.getChannels();
    },
    methods: {
        onSubmit() {
            axios({
            method: 'post',
            data: { channel: this.selectedChannel, merchantTransactionId: this.merchantTransactionId, email: this.email, amount: this.amount, currency: this.currency, emailSwitch: this.emailSwitch },
            url: 'https://controlapi.totalprocessing.com/api/create-pay-by-link',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.merchants = response.data.merchants;
                if(response.data) {
                    this.payByLink = `http://management.totalprocessing.com/pay-by-link-payment/${response.data.hash}`;
                }
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getChannels() {
            axios({
            method: 'get',
            url: 'https://controlapi.totalprocessing.com/api/get-channels',
            data: { },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.channels = response.data;
                response.data.forEach((item) => {
                this.channelsDropDown.push({value: item['entityId'], text: item['divisionName'] + " - " + item['merchantName'] + " - " + item['entityName']});
                });
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        channelHandler(value) {
            let channel = this.channels.filter(obj => {
                return obj.entityId === value
            })

            let currencies = [];

            channel[0]['currencies'].split(",").forEach((item) => {
                currencies.push({value: item, text: item});
            });

            this.selectedChannel = { merchantName: channel[0]['merchantName'],
                                     channelUuid: channel[0]['entityId'],
                                     userId: channel[0]['userId'],
                                     password: channel[0]['password'],
                                     url: 'oppwa.com',
                                     currencies: currencies};
        },
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        }
    }
}
</script>

<style>

</style>